<template>
  <div class="box" style="position: relative;">
    <div class="is-flex is-justify-content-space-between">
      <div class="mr-4" style="width: 50px;">
        <InputText :modelValue="quantity" @input="$emit('update:quantity', $event.target.value)" />
      </div>
      <div style="width: 100%;">
        <div class="is-flex is-justify-content-space-between">
          <div>
            <router-link :to="'/appuntamenti/' + operation._id">
              <h3 class="title is-5">{{ operation.type }}</h3>
            </router-link>
          </div>
          <div class="tag is-primary is-light">
            <div v-if="operation.appointment_date">
              {{new Date(operation.appointment_date).toDisplay()}}
            </div>
          </div>
        </div>
        <div class="is-size-6">
          <ClientHeading :client="operation.occupant" />
        </div>
        <div>
          <div>{{operation.place.city}}</div>
          <div>
            <small class="has-text-grey is-abbr-like" :title="$fulladdress(operation.place)">{{$fulladdress(operation.place)}}</small>
          </div>
          <div class="mt-2">
            <strong>Prezzo: € {{customPrice || listPrice || '0.00'}}</strong>
            <div v-if="vat && vatTotal" class="has-text-grey mt-1 mb-1 is-size-7">
              IVA: {{ vat }}% | Totale ivato: € {{ vatTotal }}
            </div>
            <button class="button is-small is-info ml-2" @click="$emit('editPrice')" type="button">
              <font-awesome-icon icon="pen" /> Modifica
            </button>
          </div>
        </div>
      </div>
    </div>

    <button class="button is-danger is-small" @click="$emit('delete')" title="Elimina" style="position: absolute;right: 20px;bottom: 20px;">
      <span class="icon"><font-awesome-icon icon="trash-can" /></span>
    </button>
  </div>
</template>

<script>
import InputText from './InputText.vue';

export default {
  props: ['operation', 'quantity', 'customPrice', 'listPrice', 'vat', 'vatTotal'],

  emits: ['delete', 'update:quantity', 'editPrice']
}
</script>